import API from '@/views/Fdc/Apis/'
import Modal from '@/views/Fdc/EqpInfo/Components/Modal'
import EqpCopyModal from '@/views/Fdc/EqpInfo/Components/EqpCopyModal'

/**
 * EQP Info > EQP Manager
 * EQP 정보 관리
 */
export default {
  name: 'EqpManager',
  components: {
    'modal': Modal, // Add 및 Edit Modal
    'eqp-copy-modal': EqpCopyModal // 기준정보 Copy Modal
  },
  watch: {
    // newEqpAdd (value) {
    //   if (!value) {
    //     // this.fromTreeType = 'module'
    //     // this.toTreeType = 'module'
    //     this.fromTreeType = 'eqp'
    //     this.toTreeType = 'eqp'
    //     this.fromTreenode = []
    //     this.toTreenode = []
    //   } else {
    //     this.fromTreeType = 'eqp'
    //     this.toTreeType = 'eqpModel'
    //     this.fromTreenode = []
    //     this.toTreenode = []
    //   }
    // },
    // fromTreenode (value) {
    //   let detail = value.detail
    //   if (!detail) {
    //     this.dcpDisabled = false
    //     this.newEqpAddDisabled = false
    //   } else {
    //     if (detail.eqpId !== '' && detail.moduleId !== '') {
    //       this.dcpEvent = false
    //       this.dcpTrace = false
    //       this.dcpContext = false
    //       this.dcpDisabled = true
    //       this.newEqpAdd = false
    //       this.newEqpAddDisabled = true
    //     } else {
    //       this.dcpDisabled = false
    //       this.newEqpAddDisabled = false
    //     }
    //   }
    // }
  },
  beforeMount () {
    this.initColumns()
    /**
     * Fab Key 목록 조회
     */
    API.BaseInfo.getFabsString({ useYn: 'Y' }).then((data) => {
      this.fabKeyList = data
    })

    /**
     * Fab > Line > Area > Vendor > EQP Model 목록 조회
     * Fab > Line > Area > Vendor > EQP Model 순서로 dataMap을 설정하기 위한 data 조회합니다.
     * Json 형식의 파일로 format을 변경하여 상위 요소 선택시 하위 요소를 검색할 수 있는 구조를 만듭니다.
     */
    API.BaseInfo.getFabs().then((data) => {
      this.fabList = data

      // dataMap json 형식 파일 생성
      let fabListJson = []
      let fabObj = {}
      let lineListJson = []
      let lineObj = {}
      let areaListJson = []
      let areaObj = {}
      let vendorListJson = []
      let vendorObj = {}
      let eqpModelListJson = []
      let eqpModelObj = {}

      for (var i = 0; i < data.length; i++) {
        if (data[i].fabUseYn === 'Y' &&
            data[i].fab !== null &&
            data[i].line !== null &&
            data[i].area !== null &&
            data[i].vendor !== null &&
            data[i].eqpModel !== null) {
          if (i > 0) {
            if (data[i].fab === data[i - 1].fab) {
              if (data[i].line === data[i - 1].line) {
                if (data[i].area === data[i - 1].area) {
                  if (data[i].vendor === data[i - 1].vendor) {
                    if (data[i].eqpModel !== data[i - 1].eqpModel) {
                      eqpModelObj = {}
                      eqpModelObj.eqpModel = data[i].eqpModel
                      eqpModelListJson.push(eqpModelObj)
                    }
                  } else {
                    vendorObj.eqpModelList = eqpModelListJson
                    eqpModelListJson = []

                    vendorListJson.push(vendorObj)

                    vendorObj = {}
                    vendorObj.vendor = data[i].vendor

                    eqpModelObj = {}
                    eqpModelObj.eqpModel = data[i].eqpModel
                    eqpModelListJson.push(eqpModelObj)
                  }
                } else {
                  vendorObj.eqpModelList = eqpModelListJson
                  eqpModelListJson = []

                  vendorListJson.push(vendorObj)
                  areaObj.vendorList = vendorListJson
                  vendorListJson = []

                  areaListJson.push(areaObj)

                  areaObj = {}
                  areaObj.area = data[i].area

                  vendorObj = {}
                  vendorObj.vendor = data[i].vendor

                  eqpModelObj = {}
                  eqpModelObj.eqpModel = data[i].eqpModel
                  eqpModelListJson.push(eqpModelObj)
                }
              } else {
                vendorObj.eqpModelList = eqpModelListJson
                eqpModelListJson = []

                vendorListJson.push(vendorObj)
                areaObj.vendorList = vendorListJson
                vendorListJson = []

                areaListJson.push(areaObj)
                lineObj.areaList = areaListJson
                areaListJson = []

                lineListJson.push(lineObj)

                lineObj = {}
                lineObj.line = data[i].line

                areaObj = {}
                areaObj.area = data[i].area

                vendorObj = {}
                vendorObj.vendor = data[i].vendor

                eqpModelObj = {}
                eqpModelObj.eqpModel = data[i].eqpModel
                eqpModelListJson.push(eqpModelObj)
              }
            } else {
              vendorObj.eqpModelList = eqpModelListJson
              eqpModelListJson = []

              vendorListJson.push(vendorObj)
              areaObj.vendorList = vendorListJson
              vendorListJson = []

              areaListJson.push(areaObj)
              lineObj.areaList = areaListJson
              areaListJson = []

              lineListJson.push(lineObj)
              fabObj.lineList = lineListJson
              lineListJson = []

              fabListJson.push(fabObj)

              fabObj = {}
              fabObj.fab = data[i].fab
              lineObj = {}
              lineObj.line = data[i].line
              areaObj = {}
              areaObj.area = data[i].area
              vendorObj = {}
              vendorObj.vendor = data[i].vendor
              eqpModelObj = {}
              eqpModelObj.eqpModel = data[i].eqpModel
              eqpModelListJson.push(eqpModelObj)
            }
          } else {
            fabObj.fab = data[i].fab
            lineObj.line = data[i].line
            areaObj.area = data[i].area
            vendorObj.vendor = data[i].vendor
            eqpModelObj.eqpModel = data[i].eqpModel
            eqpModelListJson.push(eqpModelObj)
          }
        }
        if (i === (data.length - 1)) {
          vendorObj.eqpModelList = eqpModelListJson
          vendorListJson.push(vendorObj)
          areaObj.vendorList = vendorListJson
          areaListJson.push(areaObj)
          lineObj.areaList = areaListJson
          lineListJson.push(lineObj)
          fabObj.lineList = lineListJson
          fabListJson.push(fabObj)
        }
      }
      this.fabListJson = fabListJson
    })
  },
  mounted () {
    // let self = this

    /**
     * excel import function set
     */
    // document.getElementById('importFileInput').addEventListener('change', function () {
    //   let fileInput = document.getElementById('importFileInput')
    //   if (fileInput.files[0]) {
    //     if (fileInput.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    //       fileInput.files[0].type !== 'application/vnd.ms-excel.sheet.macroEnabled.12') {
    //       self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_FILE_EXTENSION', ['xlsx']))
    //       self.resetFileInput()
    //       return ''
    //     }

    //     let reader = new FileReader()
    //     reader.onload = function () {
    //       let workbook = new wjcXlsx.Workbook()
    //       workbook.loadAsync(reader.result, () => {
    //         let excelcell = workbook.sheets[0].rows[0]
    //         // Column 수 계산 (count로 계산)
    //         if (excelcell.cells.length === (self.eqpManagerGrid.columns.length - 1)) {
    //           var count = 0
    //           // header 일치 여부 확인 (count로 계산)
    //           // row header column 빼고 계산
    //           for (var i = 0; i < self.eqpManagerGrid.columns.length - 1; i++) {
    //             if (excelcell.cells[i].value === self.eqpManagerGrid.columns[i + 1].header) {
    //               count++
    //             }
    //           }
    //           // header 일치 시 process start
    //           if (count === self.eqpManagerGrid.columns.length - 1) {
    //             let newRowData = []
    //             for (let i = 0; i < workbook.sheets[0].rows.length - 1; i++) {
    //               let newRow = {}

    //               newRow.fab = workbook.sheets[0].rows[i + 1].cells[0].value.toString()
    //               newRow.line = workbook.sheets[0].rows[i + 1].cells[1].value.toString()
    //               newRow.area = workbook.sheets[0].rows[i + 1].cells[2].value.toString()
    //               newRow.vendor = workbook.sheets[0].rows[i + 1].cells[3].value.toString()
    //               newRow.eqpModel = workbook.sheets[0].rows[i + 1].cells[4].value.toString()
    //               newRow.eqpId = workbook.sheets[0].rows[i + 1].cells[5].value.toString()
    //               newRow.moduleId = workbook.sheets[0].rows[i + 1].cells[6].value.toString()
    //               newRow.eqpMainYn = workbook.sheets[0].rows[i + 1].cells[7].value.toString()
    //               newRow.eqpName = workbook.sheets[0].rows[i + 1].cells[8].value.toString()
    //               newRow.useYn = workbook.sheets[0].rows[i + 1].cells[9].value.toString()

    //               newRow.isNew = true
    //               newRow['_status'] = {}
    //               newRow['_status']['checked'] = true
    //               newRow['_status']['added'] = true
    //               newRow['_status']['modified'] = false
    //               newRowData.push(newRow)
    //             }
    //             self.rowData = newRowData
    //             self.resetFileInput()
    //           } else {
    //             self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //             self.resetFileInput()
    //           }
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //           self.resetFileInput()
    //         }
    //       })
    //     }
    //     reader.readAsDataURL(fileInput.files[0])
    //   }
    // })
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 100, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LINE'), field: 'line', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.AREA'), field: 'area', width: 110, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VENDOR'), field: 'vendor', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_MODEL'), field: 'eqpModel', width: 120, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_MAIN'), field: 'eqpMainYn', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_NAME'), field: 'eqpName', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * EQP Manager 목록 조회
     * @param {String} fab Fab
     * @param {String} line Line
     * @param {String} area Area
     * @param {String} eqpModel EQP Model
     */
    async listFn (fab, line, area, eqpModel) {
      let payload = {
        fab: fab,
        line: line,
        area: area,
        eqpModel: eqpModel
      }
      let data = await API.BaseInfo.getEqps(payload)
      this.rowData = data
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * EQP 목록 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }

      let node = this.selectedTreeNode
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.listFn(node.detail.fab, node.detail.line, node.detail.area, node.detail.eqpModel)
    },
    /**
     * EQP Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.eqpManagerGrid) {
        return 0
      }
      return this.$refs.eqpManagerGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    addEnable () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.line !== null &&
          selectEqpVo.area !== null &&
          selectEqpVo.eqpModel !== null &&
          selectEqpVo.vendor !== null) {
          return true
        }
        return false
      }
    },
    // newRowAdd () {
    //   let selectEqpVo = this.searchTreeNode.detail
    //   let arr = [
    //     {
    //       fab: selectEqpVo.fab,
    //       line: selectEqpVo.line,
    //       area: selectEqpVo.area,
    //       eqpModel: selectEqpVo.eqpModel,
    //       vendor: selectEqpVo.vendor,
    //       eqpMainYn: 'Y',
    //       useYn: 'Y',
    //       isNew: true
    //     }
    //   ]
    //   let status = {
    //     checked: true,
    //     modified: false,
    //     added: true
    //   }
    //   this.$refs.eqpManagerGrid.addRows(arr, status)
    // },
    // updateComboBoxInGrid () {
    //   if (this.eqpManagerGrid) {
    //     let colEqpMainYn = this.eqpManagerGrid.columns.getColumn('eqpMainYn')
    //     if (colEqpMainYn) {
    //       colEqpMainYn.dataMapEditor = true
    //       colEqpMainYn.dataMap = this.buildDataMap(this.eqpMainYnList, 'eqpMainYn')
    //     }
    //     let colUseYn = this.eqpManagerGrid.columns.getColumn('useYn')
    //     if (colUseYn) {
    //       colUseYn.dataMapEditor = true
    //       colUseYn.dataMap = this.buildDataMap(this.useYnList, 'useYn')
    //     }
    //   }
    // },
    // buildDataMap (items, keyName) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i][keyName], value: items[i][keyName] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    /**
     * EQP Manager Grid 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.listFn(selectEqpVo.fab, selectEqpVo.line, selectEqpVo.area, selectEqpVo.eqpModel)
      }
    },
    // async saveData () {
    //   let self = this

    //   let mustSaveRows = [{
    //     fab: this.fab,
    //     line: this.line,
    //     area: this.area,
    //     vendor: this.vendor,
    //     eqpModel: this.eqpModel,
    //     eqpMainYn: this.eqpMainYn,
    //     eqpId: this.eqpId,
    //     moduleId: this.moduleId,
    //     eqpName: this.eqpName,
    //     useYn: this.useYn
    //   }]

    //   if (mustSaveRows.length < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Edit Items']))
    //     return
    //   }

    //   if (!this.saveValidation(mustSaveRows)) {
    //     return
    //   }

    //   let message = ''
    //   if (mustSaveRows.length !== 1) {
    //     message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
    //   }

    //   message += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

    //   this.$dialog.confirm({
    //     message: message,
    //     cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
    //     confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
    //     onConfirm: function () {
    //       function saveLastProcess (response) {
    //         if (response != null && response.status === 200) {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
    //           let node = self.searchTreeNode
    //           if (node.length === 0) {
    //             // excel import 할 때 search된 node 값이 없을 경우 처리
    //             let allRows = self.$refs.eqpManagerGrid.grid.rows
    //             for (var i = 0; i < allRows.length; i++) {
    //               if (allRows[i].dataItem._status) {
    //                 allRows[i].dataItem._status.checked = false
    //                 allRows[i].dataItem._status.added = false
    //                 allRows[i].dataItem._status.modified = true
    //               }
    //             }
    //           } else {
    //             self.listFn(node.detail.fab, node.detail.line, node.detail.area, node.detail.eqpModel)
    //           }
    //           self.fdcEqpTreeKey += 1

    //           // Modal Close
    //           self.eqpAddModal.visible = false
    //           self.eqpEditModal.visible = false
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
    //         }
    //       }

    //       if (mustSaveRows.length > 0) {
    //         API.FdcEqpInfo.saveEqp(mustSaveRows).then(result => {
    //           saveLastProcess(result)
    //         })
    //       }
    //     },
    //     onCancel: function () {}
    //   })
    // },
    // saveValidation (rows) {
    //   for (let i in rows) {
    //     if (!rows[i].fab || rows[i].fab.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Fab']))
    //       return false
    //     } else if (!rows[i].line || rows[i].line.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Line']))
    //       return false
    //     } else if (!rows[i].area || rows[i].area.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Area']))
    //       return false
    //     } else if (!rows[i].vendor || rows[i].vendor.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vendor']))
    //       return false
    //     } else if (!rows[i].eqpModel || rows[i].eqpModel.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Model']))
    //       return false
    //     } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
    //       return false
    //     } else if (!rows[i].moduleId || rows[i].moduleId.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
    //       return false
    //     } else if (!rows[i].eqpMainYn || rows[i].eqpMainYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Main']))
    //       return false
    //     } else if (!rows[i].eqpName || rows[i].eqpName.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Name']))
    //       return false
    //     } else if (!rows[i].useYn || rows[i].useYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Usable']))
    //       return false
    //     }
    //     let isNotMainYn = true
    //     for (let j in this.eqpMainYnList) {
    //       if (rows[i].eqpMainYn === this.eqpMainYnList[j].eqpMainYn) {
    //         isNotMainYn = false
    //       }
    //     }
    //     if (isNotMainYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Eqp Main']))
    //       return false
    //     }
    //     let isNotUseYn = true
    //     for (let j in this.useYnList) {
    //       if (rows[i].useYn === this.useYnList[j].useYn) {
    //         isNotUseYn = false
    //       }
    //     }
    //     if (isNotUseYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Usable']))
    //       return false
    //     }
    //   }
    //   return true
    // },
    // async cellEditEnd (grid, event) {
    //   let col = grid.columns[event.col]
    //   let rowData = grid.rows[event.row]._data
    //   let rowStatus = grid.rows[event.row]._data._status

    //   // modified and added row 시 자동 check (checkbox column 제외)
    //   if (col.binding !== '_status.checked') {
    //     if (rowStatus.modified || rowStatus.added) {
    //       rowStatus.checked = true
    //     }
    //   }

    //   // key validation
    //   if (rowData.isNew && rowData.eqpId && rowData.moduleId) {
    //     if (col.binding === 'eqpId' || col.binding === 'moduleId') {
    //       let payload = {
    //         fab: rowData.fab,
    //         eqpId: rowData.eqpId,
    //         moduleId: rowData.moduleId
    //       }
    //       let result = await API.FdcEqpInfo.eqpKeyValidation(payload)
    //       if (result > 0) {
    //         this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //         if (col.binding === 'eqpId') {
    //           rowData.eqpId = null
    //         } else if (col.binding === 'moduleId') {
    //           rowData.moduleId = null
    //         }
    //       } else {
    //         if (!this.newRowsKeyValidation(payload)) {
    //           this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //           if (col.binding === 'eqpId') {
    //             rowData.eqpId = null
    //           } else if (col.binding === 'moduleId') {
    //             rowData.moduleId = null
    //           }
    //         }
    //       }
    //     }
    //   }
    // },
    /**
     * EQP 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteData () {
      let self = this
      // let checkedRows = this.$refs.eqpManagerGrid.checkedRows
      // let allRows = this.$refs.eqpManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.eqpManagerGrid.gridApi.getSelectedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        // var data = _.clone(checkedRows[i])
        // delete data['_status']
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              self.listFn(node.detail.fab, node.detail.line, node.detail.area, node.detail.eqpModel)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqp(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * 기준 정보 Copy Modal 열기
     */
    openCopyModal () {
      this.eqpCopyModal.visible = true

      if (this.$refs.eqpManagerGrid.checkedRowCount === 1) {
        // let checkedRows = this.$refs.eqpManagerGrid.checkedRows
        let checkedRows = this.$refs.eqpManagerGrid.gridApi.getSelectedRows()
        let fromObj = {
          fab: checkedRows[0].fab,
          line: checkedRows[0].line,
          area: checkedRows[0].area,
          eqpModel: checkedRows[0].eqpModel,
          eqpId: checkedRows[0].eqpId,
          moduleId: checkedRows[0].moduleId
        }
        this.fromTreeObj = fromObj

        // this.initValue = {
        //   "from-eqp": fromObj,
        //   "copy-modal-type": "eqp"
        // }
      }
    },
    /**
     * 기준 정보 Copy modal 표시 여부 변경 method
     * @param {Boolean} value Modal 표시 여부
     */
    resetCopyModalData (value) {
      this.eqpCopyModal.visible = value
    },
    // async getFabKeyList () {
    //   let payload = {
    //     useYn: 'Y'
    //   }
    //   let data = await API.FdcEqpInfo.fabKeyList(payload)
    //   let list = []
    //   for (var index in data) {
    //     list.push({ fab: data[index].fab })
    //   }
    //   return list
    // },
    // async getLineKeyList (fab) {
    //   let payload = {
    //     fab: fab,
    //     useYn: 'Y'
    //   }
    //   let data = await API.FdcEqpInfo.lineKeyList(payload)
    //   let list = []
    //   for (var index in data) {
    //     list.push({ line: data[index].line })
    //   }
    //   return list
    // },
    // async getAreaKeyList (fab) {
    //   let payload = {
    //     fab: fab,
    //     useYn: 'Y'
    //   }
    //   let data = await API.FdcEqpInfo.areaKeyList(payload)
    //   let list = []
    //   for (var index in data) {
    //     list.push({ area: data[index].area })
    //   }
    //   return list
    // },
    // async getVendorKeyList (fab, area) {
    //   let payload = {
    //     fab: fab,
    //     area: area,
    //     useYn: 'Y'
    //   }
    //   let data = await API.FdcEqpInfo.vendorKeyList(payload)
    //   let list = []
    //   for (var index in data) {
    //     list.push({ vendor: data[index].vendor })
    //   }
    //   return list
    // },
    // async getEqpModelKeyList (fab, area, vendor) {
    //   let payload = {
    //     fab: fab,
    //     area: area,
    //     vendor: vendor,
    //     useYn: 'Y'
    //   }
    //   let data = await API.FdcEqpInfo.eqpModelKeyList(payload)
    //   let list = []
    //   for (var index in data) {
    //     list.push({ eqpModel: data[index].eqpModel })
    //   }
    //   return list
    // },
    // newRowsKeyValidation (params) {
    //   let allRows = this.$refs.eqpManagerGrid.grid.rows
    //   let addedRows = common.getAddedRows(allRows)
    //   let result = true
    //   let sameDataCnt = 0
    //   for (var i in addedRows) {
    //     if (addedRows[i].fab === params.fab &&
    //       addedRows[i].eqpId === params.eqpId &&
    //       addedRows[i].moduleId === params.moduleId &&
    //       addedRows[i].eqpId && addedRows[i].moduleId) {
    //       // result = false
    //       // break
    //       sameDataCnt++
    //     }
    //   }
    //   if (sameDataCnt > 1) {
    //     result = false
    //   }
    //   return result
    // },
    /**
     * Csv Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportCsv () {
      // this.$refs.eqpManagerGrid.exportExcel('EqpManager')
      this.$refs.eqpManagerGrid.gridApi.exportDataAsCsv({
        fileName: 'EqpManager.csv'
      })
    },
    /**
     * Csv Import
     * csv을 import 할 수 있도록 파일 선택창을 띄웁니다.
     */
    importCsv () {
      this.$refs.eqpManagerGrid.onClickImportCsv()
      // this.resetFileInput()
      // document.getElementById('importFileInput').click()
    },
    /**
     * File value 초기화
     * 선택된 파일을 초기화 합니다.
     */
    // resetFileInput () {
    //   document.getElementById('importFileInput').value = ''
    // },
    /**
     * EQP Add Modal 초기 data 설정
     */
    initAddModal () {
      let data = this.searchTreeNode.detail

      this.initValue = {
        saveType: 'Add',
        fab: data.fab,
        line: data.line,
        area: data.area,
        vendor: data.vendor,
        eqpModel: data.eqpModel,
        eqpMainYn: 'Y',
        useYn: 'Y'
      }
    },
    /**
     * EQP Edit Modal 초기 data 설정
     */
    initEditModal () {
      // const rows = this.$refs.eqpManagerGrid.grid.rows.filter(row => row.dataItem._status)
      // const data = rows.find(row => row.dataItem._status.checked).dataItem
      const checkedRowData = this.$refs.eqpManagerGrid.gridApi.getSelectedRows()[0]
      checkedRowData.saveType = 'Edit'
      this.initValue = checkedRowData
    },
    /**
     * EQP Add/Edit Modal data 초기화
     */
    resetModalInitValue () {
      this.initValue = {}
    },
    /**
     * EQP Add/Edit Modal close
     */
    closeSaveModel () {
      this.eqpSaveModal.visible = false
    },
    // closeAddModel () {
    //   this.eqpAddModal.visible = false
    // },
    // closeEditModel () {
    //   this.eqpEditModal.visible = false
    // },
    // closeCopyModel () {
    //   this.eqpCopyModal.visible = false
    // },
    /**
     * EQP Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.eqpManagerGrid) {
        return 0
      }
      return this.$refs.eqpManagerGrid.checkedRowCount === 1
    },
    /**
     * EQP Add Modal 열기
     */
    addRow () {
      this.eqpSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0017')
      this.initAddModal()
    },
    /**
     * EQP Edit Modal 열기
     */
    editRow () {
      this.eqpSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0018')
      this.initEditModal()
    },
    // async changeArea () {
    //   console.log(this.fab, this.area)
    //   this.vendorList = await this.getVendorKeyList(this.fab, this.area)
    // },
    // async changeVendor () {
    //   console.log(this.fab, this.area, this.vendor)
    //   this.eqpModelList = await this.getEqpModelKeyList(this.fab, this.area, this.vendor)
    // },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.eqpManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Eqp')
      }
    },
    /**
     * EQP Tree Refresh
     * EQP 저장 시 호출합니다.
     * 신규 장비가 추가될 때 기존 EQP Tree에 없는 FAB > Line > Area > EQP Model 정보가 추가되는 경우 EQP Tree에 바로 적용하기 위해 호출합니다.
     */
    refreshEqpTree () {
      this.fdcEqpTreeKey += 1
    }
  },
  data () {
    return {
      eqpManagerGrid: null, // EQP Manager Grid 객체
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 70, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.LINE'), binding: 'line', width: 70, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.AREA'), binding: 'area', width: 110, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VENDOR'), binding: 'vendor', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_MODEL'), binding: 'eqpModel', width: 120, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_MAIN'), binding: 'eqpMainYn', width: 100/*, dataMap: 'eqpMainYnList' */, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_NAME'), binding: 'eqpName', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 90/*, dataMap: 'useYnList' */, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 150, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // grid column 배열
      columns: [], // grid column 배열
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      fabList: [], // Fab 목록 배열 (FAb Manager 목록과 동일)
      fabListJson: [], // Grid Data Map을 위한 json data
      // keyComboBoxList: ['fab', 'line', 'area', 'vendor', 'eqpModel'],
      fabKeyList: [], // FAB Key 목록 배열
      // eqpMainYnList: [
      //   { eqpMainYn: 'Y' },
      //   { eqpMainYn: 'N' }
      // ],
      // useYnList: [
      //   { useYn: 'Y' },
      //   { useYn: 'N' }
      // ],
      // collectionViewOptions: {
      //   // groupDescriptions: ['fab']
      // },
      eqpCopyModal: { visible: false }, // EQP Copy Modal 표시 여부
      fromTreeObj: null, // EQP Copy Modal에 From EQP Tree Object
      fdcEqpTreeKey: 0, // EQP Tree를 refresh하기 위한 data
      initValue: {}, // EQP Save Modal 초기 data
      modalTitle: '', // EQP Save Modal Title
      eqpSaveModal: {
        visible: false
      } // EQP Save Modal 표시 여부
    }
  }
}
